"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PARTICIPANT_NAME_MAXLENGTH = exports.PARTICIPANT_PRINCIPAL_EXACT_LENGTH = exports.PROJECT_NAME_MAXLENGTH = exports.PARAMETER_VALUE_MAXLENGTH = exports.PARAMETER_KEY_MAXLENGTH = void 0;
exports.PARAMETER_KEY_MAXLENGTH = 100;
exports.PARAMETER_VALUE_MAXLENGTH = 20000;
exports.PROJECT_NAME_MAXLENGTH = 100;
exports.PARTICIPANT_PRINCIPAL_EXACT_LENGTH = 63;
exports.PARTICIPANT_NAME_MAXLENGTH = 100;
